/**
 * Karussell-Wiedergabegeschwindigkeit (Lernmodus)
 *
 * Drei Modi: Langsamer (0,25×), Langsam (0,5×), Original (1× mit Musik-Sync).
 * UI-Texte: `dashboard.carouselPlayback.*`
 */

export const CAROUSEL_PLAYBACK_SPEEDS = [0.25, 0.5, "sync"] as const;

export type CarouselPlaybackSpeed = (typeof CAROUSEL_PLAYBACK_SPEEDS)[number];

export const DEFAULT_CAROUSEL_PLAYBACK_SPEED: CarouselPlaybackSpeed = "sync";

/** Erlaubte numerische Geschwindigkeiten (für Playback-Rate). "sync" wird als 1 behandelt. */
export const CAROUSEL_PLAYBACK_SPEED_NUMERIC = [0.25, 0.5] as const;

/** Prüft, ob ein Wert eine gültige Karussell-Geschwindigkeit ist */
export function isCarouselPlaybackSpeed(
  value: number | string
): value is CarouselPlaybackSpeed {
  return CAROUSEL_PLAYBACK_SPEEDS.includes(value as CarouselPlaybackSpeed);
}

/** Liefert den numerischen Multiplikator für die Wiedergabe. "sync" → 1, sonst 0.25 oder 0.5. */
export function carouselSpeedToMultiplier(
  speed: CarouselPlaybackSpeed
): number {
  return speed === "sync" ? 1 : speed;
}

/** Clampt auf die nächste erlaubte Geschwindigkeit (0.25, 0.5 oder sync). */
export function clampToCarouselPlaybackSpeed(
  value: number | string
): CarouselPlaybackSpeed {
  if (value === "sync") return "sync";
  const n = typeof value === "number" ? value : parseFloat(String(value));
  if (!Number.isFinite(n)) return DEFAULT_CAROUSEL_PLAYBACK_SPEED;
  if (n <= 0.375) return 0.25;
  if (n < 0.75) return 0.5;
  return "sync";
}
